export function UploadingFile() {
    return (
        <div>
            <p>Uploading file...</p>
        </div>
    );
}
